import numeral from 'numeral';
import { CurrencyCode } from '../types/currency';

/**
 * @param {number | string | NaN | Infinity} n
 */
export const isNumber = (n) =>
  !Number.isNaN(parseFloat(n)) && Number.isFinite(n);

/**
 * Formats a number as a currency string based on the provided currency code
 * @param {number} amount - The amount to format
 * @param {string} currencyCode - The ISO 4217 currency code (e.g. 'USD', 'EUR', 'GBP')
 * @param {Object} options - Additional formatting options
 * @param {boolean} options.useSymbol - Whether to use the currency symbol (default: true)
 * @param {string} options.locale - The locale to use for formatting (default: 'en-US')
 * @returns {string} - The formatted currency string
 */
export const toLocaleCurrency = (amount, currencyCode, options = {}) => {
  const { useSymbol = true, locale = 'en-US' } = options;

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: useSymbol ? 'symbol' : 'code',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (error) {
    console.error(`Error formatting currency: ${error.message}`);
    return `${currencyCode} ${amount.toFixed(2)}`;
  }
};

export const toCurrency = (n) => numeral(n).format('$0,0.00');
export const toCurrency_4 = (n) => numeral(n).format('$0,0.0000');

export const toPercent = (n) => numeral(n).format('0.0%');
export const toPercent_2 = (n) => numeral(n).format('0.00%');
export const toPercent_3 = (n) => numeral(n).format('0.000%');
export const toPercentRounded = (n) => numeral(n).format('0%');

export const toFixed_2 = (n) => numeral(n).format('0.00');
export const toFixed_3 = (n) => numeral(n).format('0.000');

export const toInt = (n) => numeral(n).format('0,0');
export const toLocale_2 = (n) =>
  Number(n).toLocaleString('en', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }); // 1,000.00

export const strToNum = (n) => numeral(n).value();

export const generateRandomNumberString = (numDigits) => {
  const min = Math.pow(10, numDigits - 1);
  const max = Math.pow(10, numDigits) - 1;
  const randomNumber = Math.floor(min + Math.random() * (max - min + 1));
  return randomNumber.toString();
};

/**
 * by default, lower change is given positive percent diff
 */
export const findPercentDifference = (originalValue, newValue, preferLower) => {
  if (!originalValue) {
    return null;
  }

  const percentDifference = (newValue - originalValue) / originalValue;

  return percentDifference;
};
